import { render, staticRenderFns } from "./emailCustomContentDialog.vue?vue&type=template&id=509afd90&scoped=true&"
import script from "./emailCustomContentDialog.vue?vue&type=script&lang=js&"
export * from "./emailCustomContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./emailCustomContentDialog.vue?vue&type=style&index=0&id=509afd90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509afd90",
  null
  
)

export default component.exports